// src/routes/statistics/report/components/ChartComponent.js

import React from 'react';
import { Line, Bar } from 'react-chartjs-2';

const ChartComponent = ({ displayedData, lastSearchMode }) => {
  return (
    <div className="chartHour-chart-container" style={{ width: '90%' }}>
      {displayedData && displayedData.labels && displayedData.datasets ? (
        lastSearchMode === 'total' ? (
          <Bar
            data={displayedData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { position: 'top' },
                tooltip: {
                  callbacks: {
                    label: function (tooltipItem) {
                      const label = tooltipItem.dataset.label;
                      const value = tooltipItem.raw;

                      let unit = '';
                      let displayValue = value;

                      if (label.includes('일사량')) {
                        unit = 'W/m²';
                      } else if (label.includes('온도')) {
                        unit = '℃';
                      } else {
                        unit = 'kWh';
                        displayValue = value / 1000;
                      }

                      return `${label}: ${displayValue.toFixed(2)} ${unit}`;
                    },
                  },
                },
              },
              scales: {
                x: { title: { display: true } },
                y: {
                  type: 'linear',
                  position: 'left',
                  title: { display: true, text: '발전량 (kWh)' },
                  ticks: {
                    callback: function (value) {
                      return value / 1000 + ' kWh';
                    },
                  },
                },
                y1: {
                  type: 'linear',
                  position: 'right',
                  title: { display: true, text: '환경센서 (일사량 / 온도)' },
                  grid: { drawOnChartArea: false },
                },
              },
            }}
            width={800}
            height={400}
          />
        ) : (
          <Line
            data={displayedData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { position: 'top' },
                tooltip: {
                  callbacks: {
                    label: function (tooltipItem) {
                      const label = tooltipItem.dataset.label;
                      const value = tooltipItem.raw;

                      let unit = 'kWh';
                      let displayValue = value / 1000;

                      if (label.includes('일사량')) {
                        unit = 'W/m²';
                        displayValue = value;
                      } else if (label.includes('온도')) {
                        unit = '℃';
                        displayValue = value;
                      }

                      return `${label}: ${displayValue.toFixed(2)} ${unit}`;
                    },
                  },
                },
              },
              scales: {
                x: { title: { display: true } },
                y: {
                  type: 'linear',
                  position: 'left',
                  title: { display: true, text: '발전량 (kWh)' },
                  ticks: {
                    callback: function (value) {
                      return value / 1000 + ' kWh';
                    },
                  },
                },
                y1: {
                  type: 'linear',
                  position: 'right',
                  title: { display: true, text: '환경센서 (일사량 / 온도)' },
                  grid: { drawOnChartArea: false },
                },
              },
              elements: {
                line: { tension: 0.4 },
                point: { radius: 2, hoverRadius: 5 },
              },
            }}
            width={800}
            height={400}
          />
        )
      ) : (
        <p style={{ textAlign: 'center' }}>날짜를 선택하고 검색을 눌러주세요.</p>
      )}
    </div>
  );
};

export default ChartComponent;